export default __webpack_public_path__ + "static/media/storageUnit1-afterC-480w.aa7adc40.webp";